import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useUnitConnectorColors } from '../../../hooks/useUnitConnectorColors';

interface Props {
  type: DashboardConnectorType;
}

export const VerticalConnector: FC<Props> = ({ type }) => {
  const connectorColors = useUnitConnectorColors();
  const verticalConnectors = {
    locked: (
      <svg width="15" height="170" viewBox="0 0 15 170" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="170" height="15" transform="translate(7.43094e-06 170) rotate(-90)" fill="#EBE4DC" />
      </svg>
    ),
    unlocked: (
      <svg width="15" height="170" viewBox="0 0 15 170" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_2297_31386" fill="white">
          <path d="M7.43094e-06 170L0 6.55671e-07L15 0L15 170L7.43094e-06 170Z" />
        </mask>
        <path
          d="M7.43094e-06 170L4.00001 170L4 4.80825e-07L0 6.55671e-07L-4 8.30516e-07L-3.99999 170L7.43094e-06 170ZM15 0L11 1.74845e-07L11 170L15 170L19 170L19 -1.74846e-07L15 0Z"
          className={connectorColors.fillBase}
          mask="url(#path-1-inside-1_2297_31386)"
        />
      </svg>
    ),
    passed: (
      <svg width="15" height="170" viewBox="0 0 15 170" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          width="170"
          height="15"
          transform="translate(7.43094e-06 170) rotate(-90)"
          className={connectorColors.fillBase}
        />
      </svg>
    ),
  };

  return verticalConnectors[type];
};
